import { z } from "zod";

/**
 * VELİ RAPORU — TELDEN GEÇEN ŞEKİLLER (F-REP)
 *
 * ================================================================
 * NEDEN BU DOSYA AÇILDI
 * ================================================================
 * `sonRevizyonGerekcesi` 04.09.2026'da eklendi ve **aynı gün iki
 * yerde** tanımlandı: sunucuda `rapor-kural.ts`, panelde
 * `apps/panel/src/api.ts`. İkisi de doğruydu, ikisi de elle yazılmıştı.
 *
 * Bu depoda o sınıf aynı gün **yedi** sapma üretti (`golgeleme.test.ts`
 * ölçtü): aynı ad iki farklı değer, aynı iş iki farklı şekil, iki ayrı
 * kural aynı ad. Sekizincisini **oluşmadan** kapatıyoruz.
 *
 * Ayrışma burada sessiz olurdu: sunucu `yazan`ı kaldırsa panel tipi
 * hâlâ `string | null` der, derleyici susar ve ekran **hiç dolmayacak**
 * bir alanı çizmeye devam ederdi.
 *
 * ================================================================
 * `tarih` NEDEN `string`
 * ================================================================
 * Sunucunun iç tipi `Date`; telde JSON olduğu için ISO **dizgi**.
 * Sözleşme **telden geçeni** tarif eder — istemcinin gerçekten
 * gördüğünü. `Date` yazsaydık panel `.getTime()` çağırır ve çalışma
 * anında patlardı; tip doğru görünür, davranış yanlış olurdu.
 */
export const revizyonGerekcesiSemasi = z.object({
  /** Boşluktan ibaret metin sunucuda `null`a çevriliyor; buraya hiç gelmez. */
  metin: z.string().min(1),
  /**
   * Yazan arşivlenmişse `null` (veritabanında `ON DELETE SET NULL`).
   *
   * Metin yine duruyor: uzmanın düzelteceği şey kim yazdığından
   * bağımsız. Yer tutucu bir ad ("Bilinmeyen kullanıcı") ÜRETİLMİYOR —
   * olmayan bir ölçümü varmış gibi göstermek olurdu.
   */
  yazan: z.string().nullable(),
  /** ISO 8601. Eski kayıtlarda `null` olabilir. */
  tarih: z.string().nullable(),
});

/**
 * Raporu hazırlayan uzmana ULAŞAN revizyon gerekçesi — F-REP-09.
 *
 * "Revizyon istendi" durumu uzmandan iş istiyor; neyi düzelteceğini
 * söylemeyen bir iş emri, iş emri değildir.
 *
 * DİKKAT — EKRANI DURUMA BAĞLAMA: gerekçe bir sonraki geçişte
 * SİLİNMİYOR. Uzman düzeltmeyi yapıp raporu onaya geri gönderdiğinde
 * (`AWAITING_REVIEW`) metin duruyor, çünkü *"istenen buydu, yaptım
 * mı?"* diye bakılacak an tam da odur. Bölüm `status`e değil, **verinin
 * varlığına** bakmalı.
 */
export type RevizyonGerekcesiSozlesme = z.infer<typeof revizyonGerekcesiSemasi>;
